import {assert} from 'Asserts';
import {
  ProcessGraphBuilderNode,
  ProcessTaskSchemaForGraphBuilderValidation,
} from 'processes/graph-builder-processes/validation/ProcessGraphBuilderConstants';

import {ProcessInteractiveFlowchart, ProcessFlowchartInteractiveNode} from '../ProcessFlowchartVizConstants';
import convertProcessFlowchartNodesToGraphBuilderNodes from './convertProcessFlowchartNodesToGraphBuilderNodes';
import {isRootNode, isRouterNode, isTaskNode} from './getNodeDetailsTypeForInteractiveNode';

/** Returns child nodes of the routerNode that are directly connected to the routerNode  */
export default function getImmediateChildNodesForRouterNode(
  flowchart: ProcessInteractiveFlowchart,
  routerInputNode: ProcessFlowchartInteractiveNode,
  routerNode: ProcessFlowchartInteractiveNode,
  flowchartSchema: ProcessTaskSchemaForGraphBuilderValidation
): Array<ProcessGraphBuilderNode> {
  assert(
    isTaskNode(routerInputNode) || isRootNode(routerInputNode),
    'Input node to router must be a task or root node.'
  );
  assert(isRouterNode(routerNode), 'Router node must have router node details.');

  const routerNodeOutboundNodes = flowchart.nodes.filter((node) =>
    flowchart.edges.some(
      (edge) => edge.fromNodeClientId === routerNode.clientId && edge.toNodeClientId === node.clientId
    )
  );

  return convertProcessFlowchartNodesToGraphBuilderNodes(routerNodeOutboundNodes, flowchartSchema);
}
